import React, { useEffect, useState } from 'react'
import { Wrapper } from './styles'
import CloseButton from 'src/global/CloseButton'
import { GlassButton } from 'src/global'
import { hasActiveOnboardingPackageRequest } from 'src/helpers/onboardingPackage'

type Props = {
  isDismissed: boolean
  onDismiss: () => void
}

export default function OnboardingPackagePanel({ isDismissed, onDismiss }: Props) {
  const [hasSubmitted, setHasSubmitted] = useState(() => hasActiveOnboardingPackageRequest())
  const [modalOpen, setModalOpen] = useState(false)

  useEffect(() => {
    const update = () => {
      setHasSubmitted(hasActiveOnboardingPackageRequest())
    }
    window.addEventListener('onboarding-package-submitted', update)
    return () => {
      window.removeEventListener('onboarding-package-submitted', update)
    }
  }, [])

  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent).detail
      setModalOpen(!!detail?.isOpen)
    }
    window.addEventListener('onboarding-package-modal:change', handler)
    return () => window.removeEventListener('onboarding-package-modal:change', handler)
  }, [])

  if (hasSubmitted) {
    return (
      <Wrapper $isDismissed={isDismissed} $isFaded={modalOpen}>
        <CloseButton onClick={onDismiss} title="Închide" color="#ffffff" style={{ marginTop: '-16px', right: '16px' }} />
        <div className="glass">
          <h3 className="title">Digitalizare Meniu - cerere în curs</h3>
          <p className="description">
            Ți-am trimis pe email rezumatul cererii și lista informațiilor de care avem nevoie. Răspunde acolo cu materialele
            cerute.
          </p>
          <GlassButton onClick={onDismiss}>Ok</GlassButton>
        </div>
      </Wrapper>
    )
  }

  return (
    <Wrapper $isDismissed={isDismissed} $isFaded={modalOpen}>
      <CloseButton onClick={onDismiss} title="Închide" color="#ffffff" style={{ marginTop: '-16px', right: '16px' }} />
      <span className="badge">NOU</span>
      <div className="glass">
        <h3 className="title">Vrei să-ți importăm noi meniul?</h3>
        <p className="description">
          Am lansat un pachet menit să te ajute să pornești la drum cât mai repede. Ne ocupăm de importul produselor, organizarea
          meniului și restul configurării inițiale.
        </p>
        <div className="cta" onClick={() => window.openOnboardingPackageModal()}>
          <span>Află mai multe</span>
        </div>
      </div>
    </Wrapper>
  )
}
